import type { GetGlobalServiceInformationTemplatesNormalized } from '@messenger/types'
import {
  createGlobalServiceInformationTemplateSchema,
  getGlobalServiceInformationTemplatesQuerySchema,
  updateGlobalServiceInformationTemplateSchema,
} from '@messenger/types'
import axios from '@/api/axios.config'
import { z } from 'zod'

export const createServiceInformationTemplate = async (
  payload: z.infer<typeof createGlobalServiceInformationTemplateSchema>,
) => {
  return await axios.post<GetGlobalServiceInformationTemplatesNormalized>(
    'globalServiceInformationTemplates',
    payload,
  )
}

export const updateServiceInformationTemplate = async (
  id: string,
  payload: z.infer<typeof updateGlobalServiceInformationTemplateSchema>,
) => {
  return await axios.patch<GetGlobalServiceInformationTemplatesNormalized>(
    `globalServiceInformationTemplates/${id}`,
    payload,
  )
}

export const deleteServiceInformationTemplate = async (id: string) => {
  return await axios.delete<{ success: boolean }>(
    `globalServiceInformationTemplates/${id}`,
  )
}

export const getServiceInformationTemplates = async (
  productId: z.infer<
    typeof getGlobalServiceInformationTemplatesQuerySchema
  >['productId'],
) => {
  return await axios.get<GetGlobalServiceInformationTemplatesNormalized[]>(
    `globalServiceInformationTemplates?productId=${productId}`,
  )
}
